var _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCamera(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 16,
    r: 11,
    stroke: "#1A2021",
    strokeWidth: 2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.4945 11.7321L13.2508 12.4286H11.5C10.6727 12.4286 10 13.0692 10 13.8571V19.5714C10 20.3594 10.6727 21 11.5 21H20.5C21.3273 21 22 20.3594 22 19.5714V13.8571C22 13.0692 21.3273 12.4286 20.5 12.4286H18.7492L18.5055 11.7321C18.3531 11.2946 17.9242 11 17.4391 11H14.5609C14.0758 11 13.6469 11.2946 13.4945 11.7321ZM16 18.8571C14.7578 18.8571 13.75 17.8973 13.75 16.7143C13.75 15.5312 14.7578 14.5714 16 14.5714C17.2422 14.5714 18.25 15.5312 18.25 16.7143C18.25 17.8973 17.2422 18.8571 16 18.8571Z",
    fill: "#1A2021"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCamera);
export default __webpack_public_path__ + "static/media/camera.d8256bb43ab7d1a258b5e2c57fd0e7dc.svg";
export { ForwardRef as ReactComponent };